import React from 'react';
import {
  Box,
  SimpleGrid,
  Stat,
  StatLabel,
  StatNumber,
  StatHelpText,
  StatArrow,
  Text,
} from '@chakra-ui/react';

const colors = {
  gold: "#FFD700",
  emerald: "#50C878",
  sapphire: "#0F52BA",
  ruby: "#E0115F",
};

const StatsOverview = ({ stats }) => {
  return (
    <Box
      bg="gray.900"
      p={6}
      borderRadius="xl"
      borderWidth="1px"
      borderColor={colors.gold}
      mb={6}
      boxShadow="0 0 20px rgba(255, 215, 0, 0.1)"
    >
      <SimpleGrid columns={{ base: 1, md: 2, lg: 4 }} spacing={6}>
        {/* Total NFTs */}
        <Stat>
          <StatLabel color={colors.gold}>My Angels Keys</StatLabel>
          <StatNumber fontSize="3xl" color="white">
            {stats.totalNFTs}
          </StatNumber>
          <StatHelpText color="green.400">
            <StatArrow type="increase" />
            Active NFTs
          </StatHelpText>
        </Stat>

        {/* Total Earnings */}
        <Stat>
          <StatLabel color={colors.gold}>Total Earnings</StatLabel>
          <StatNumber color="#32CD32">
            {stats.totalEarned.jinu.toLocaleString(undefined, { maximumFractionDigits: 2 })} JINU
          </StatNumber>
          <StatHelpText color="#32CD32">
            ${stats.totalEarned.usd.toLocaleString(undefined, { maximumFractionDigits: 2 })} USD
          </StatHelpText>
          <Text fontSize="xs" color="white">
            Based on the last 365 days
          </Text>
        </Stat>

        {/* Last Period */}
        <Stat>
          <StatLabel color={colors.gold}>Last Period</StatLabel>
          <StatNumber color="#32CD32">
            {stats.lastPeriod.jinu.toLocaleString(undefined, { maximumFractionDigits: 2 })} JINU
          </StatNumber>
          <StatHelpText color="#32CD32">
            ${stats.lastPeriod.usd.toLocaleString(undefined, { maximumFractionDigits: 2 })} USD
          </StatHelpText>
          <Text fontSize="xs" color="white">
            Your share the last 31 days
          </Text>
        </Stat>

        {/* Daily Average per NFT */}
        <Stat>
          <StatLabel color={colors.gold}>Daily Average/NFT</StatLabel>
          <StatNumber color="#32CD32">
            {stats.dailyAverage.jinu.toLocaleString(undefined, { maximumFractionDigits: 2 })} JINU
          </StatNumber>
          <StatHelpText color="#32CD32">
            ${stats.dailyAverage.usd.toLocaleString(undefined, { maximumFractionDigits: 2 })} USD
          </StatHelpText>
          <Text fontSize="xs" color="white">
            Earned Last 24h
          </Text>
        </Stat>
      </SimpleGrid>
    </Box>
  );
};

export default StatsOverview;
